import { cn } from "@/shared/lib/utils";

type CardUsageChartProps = {
  data: ReadonlyArray<{ l: string; v: number }>;
  className?: string;
};

export const CardUsageChart = ({ data, className }: CardUsageChartProps) => {
  const max = Math.max(1, ...data.map((d) => d.v));

  return (
    <div className={cn("flex h-28 items-end gap-2", className)}>
      {data.map((d, i) => {
        const isLast = i === data.length - 1;
        const heightPct = (d.v / max) * 100;
        return (
          <div key={`${d.l}-${i}`} className="flex flex-1 flex-col items-center gap-1.5">
            <div className="flex w-full flex-1 items-end">
              <div
                className={cn("w-full rounded-t-sm transition-all", isLast ? "bg-primary" : "bg-primary/20")}
                style={{ height: `${heightPct}%` }}
              />
            </div>
            <div className="font-mono text-[10px] text-muted-foreground">{d.l}</div>
          </div>
        );
      })}
    </div>
  );
};
